import clickElement from './click-element';
import event, {EVENTS} from '../../lib/event';
import ScratchBlocks from 'scratch-blocks';
import {BATCH_TIPS_MODE} from '../../lib/constant';

const categoryMap = {
    运动: 'scratchCategoryId-motion',
    外观: 'scratchCategoryId-looks',
    声音: 'scratchCategoryId-sound',
    事件: 'scratchCategoryId-events',
    控制: 'scratchCategoryId-control',
    侦测: 'scratchCategoryId-sensing',
    运算: 'scratchCategoryId-operators',
    变量: 'scratchCategoryId-variables',
    自制积木: 'scratchCategoryId-myBlocks',
    data: 'scratchCategoryId-variables',
    'data-lists': 'scratchCategoryId-variables',
    画笔: 'scratchCategoryId-pen',
    音乐: 'scratchCategoryId-music',
    //TODO 需要增加更多
};

/**
 * 引导用户点击左侧代码类别按钮
 * @param {string} id - 分类名称，可以是原始的categoryId或中文名称：运动、外观、声音、事件、控制、侦测、运算、变量、自制积木
 * @param {string} tips - 提示，默认为`请点击${categoryName}`
 * @param {boolean} noTips - 不显示tips
 * @returns {Promise} 执行成功的 Promise，这个方法不可能失败
 */
function switchGroup ({id, tips, noTips}, mode, _index) {
    //代码中通过mode是否为undefined来判断是否要显示聊天记录，因此这里不能初始化 if (mode === undefined) mode = stepsRuntime.mode;
    if (_index === undefined) _index = {stepIndex: stepsRuntime.stepIndex, actionIndex: stepsRuntime.actionIndex};
    return new Promise((resolve, reject) => {
        const onAbort = ()=>{
            reject('Step Abort');
        }
        event.once(EVENTS.STEP_ABORT, onAbort);
        const wrapResolve = arg => {
            resolve(arg);
            event.off(EVENTS.STEP_ABORT, onAbort);
        }
        const wrapReject = arg => {
            reject(arg);
            event.off(EVENTS.STEP_ABORT, onAbort);
        }
        let catClass = categoryMap[id];
        if (catClass == undefined) catClass = 'scratchCategoryId-' + id;
        if (mode) {
            if (!noTips) {
                if (!tips) {
                    let element = document.querySelector('.' + catClass);
                    if (element) {
                        tips = '点击切换到『' + element.innerText.trim() + '』积木组';
                    }
                }
                window.stepsRuntime.insertTips(_index, tips, true);
            }
            if (mode === BATCH_TIPS_MODE) {
                return new Promise(resolve => {
                    wrapResolve();
                })
            }
        }
        if (window.toolbox.flyout_.isVisible() && 'scratchCategoryId-' + window.toolbox.getSelectedCategoryId() == catClass) {
            wrapResolve(true);
        }else {
            let element = document.querySelector('.' + catClass);
            if (!element) {
                wrapReject(`${catClass}未找到`);
                return;
            }
            if (!tips) {
                tips = '点击切换到『' + element.innerText.trim()  + '』积木组';
            }
            const rect = element.getBoundingClientRect();
            const scrollNode = document.querySelector('.scratchCategoryMenu').parentElement;
            const scrollNodeRect = scrollNode.getBoundingClientRect();
            if (rect.top < scrollNodeRect.top) {
                scrollNode.scrollTop += rect.top - scrollNodeRect.top;
            }else if (rect.top > scrollNodeRect.bottom - 51) {
                scrollNode.scrollTop += rect.top - scrollNodeRect.bottom + 51;
            }
            clickElement({element: `.${catClass}`, tips, noTips}).then(() => {
                let intval = setInterval(()=>{
                    if (window.toolbox.flyout_.scrollTarget == null) { //等待滚动动画结束
                        clearInterval(intval);
                        console.log("switch group finish");
                        wrapResolve(true);
                    }
                }, 100);
            }, () => {
                wrapReject();
            });
        }
    });
}

export {
    switchGroup as default,
    categoryMap
}
